import { render, staticRenderFns } from "./XWorkList.vue?vue&type=template&id=3191d08c&scoped=true"
import script from "./XWorkList.vue?vue&type=script&lang=js"
export * from "./XWorkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191d08c",
  null
  
)

export default component.exports